const discount = (price, percentDisc) => price * (percentDisc / 100)

const discountPrice = (price, percentDisc) =>
  price - discount(price, percentDisc)

const breakdownPrice = ({ gross, net, tax, service }, qty, percentDisc) => ({
  gross: discountPrice(gross * qty, percentDisc),
  net: discountPrice(net * qty, percentDisc),
  discount: discount(gross * qty, percentDisc),
  tax: discountPrice(tax * qty, percentDisc),
  service: discountPrice(service * qty, percentDisc),
})

const reducePrice = (items) =>
  items.reduce(
    (prev, cur) => {
      if (!prev.currency) prev.currency = cur.currency
      prev.gross += cur.gross
      prev.discount += cur.discount
      prev.tax += cur.tax
      prev.service += cur.service
      prev.net += cur.net

      return prev
    },
    { currency: null, gross: 0, net: 0, discount: 0, tax: 0, service: 0 }
  )

const totalBreakdownPrice = (items, key = null) => {
  if (!key) return reducePrice(items)

  const base = items.map((item) => item[key])
  return reducePrice(base)
}

const sumBreakdownPrice = (firstBreakdown, secondBreakdown) => {
  const result = {}

  Object.keys(firstBreakdown).forEach((key, index) => {
    if (isNaN(firstBreakdown[key])) {
      result[key] = firstBreakdown[key]
    } else {
      result[key] = firstBreakdown[key] + secondBreakdown[key]
    }
  })

  return result
}

const multiplyRate = (rate, multiplier) =>
  Object.keys(rate).reduce((res, key) => {
    if (isNaN(rate[key])) {
      res[key] = rate[key]
    } else {
      res[key] = rate[key] * multiplier
    }

    return res
  }, {})

const payloadPrice = (price) => ({
  currency: price.currency,
  net: price.net,
  discount: price.discount,
  tax: price.tax,
  service: price.service,
  gross: price.gross,
})

export default {
  discount,
  discountPrice,
  breakdownPrice,
  reducePrice,
  totalBreakdownPrice,
  sumBreakdownPrice,
  multiplyRate,
  payloadPrice,
}
